import { render, staticRenderFns } from "./NotasNivel1DadosAgrupado.vue?vue&type=template&id=22224dd4&scoped=true"
import script from "./NotasNivel1DadosAgrupado.vue?vue&type=script&lang=js"
export * from "./NotasNivel1DadosAgrupado.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel1DadosAgrupado.vue?vue&type=style&index=0&id=22224dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22224dd4",
  null
  
)

export default component.exports